module.exports = __webpack_public_path__ + "img/b1.cd5a2cc2.png";